import { type IconSize } from './icon.variants';

// ---------------------------------------------------------------------------
// Source
// ---------------------------------------------------------------------------

export type IconSource = 'primeng' | 'lucide' | 'svg';

export enum IconSourceEnum {
  PRIMENG = 'primeng',
  LUCIDE  = 'lucide',
  SVG     = 'svg',
}

// ---------------------------------------------------------------------------
// Size
// ---------------------------------------------------------------------------

export { IconSize };

export enum IconSizeEnum {
  XXS     = 'xxs',
  XS      = 'xs',
  SM      = 'sm',
  DEFAULT = 'default',
  MD      = 'md',
  LG      = 'lg',
  XL      = 'xl',
  XXL     = 'xxl',
}

// ---------------------------------------------------------------------------
// Variant (colour / severity)
// ---------------------------------------------------------------------------

export type IconVariant =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'theme'
  | 'muted'
  | 'black';

export enum IconVariantEnum {
  DEFAULT   = 'default',
  PRIMARY   = 'primary',
  SECONDARY = 'secondary',
  SUCCESS   = 'success',
  DANGER    = 'danger',
  THEME     = 'theme',
  MUTED     = 'muted',
  BLACK     = 'black',
}

// ---------------------------------------------------------------------------
// Internal maps
// ---------------------------------------------------------------------------

export const VARIANT_COLOR_MAP: Record<IconVariant | string, string> = {
  default:   'text-gray-700',
  primary:   'text-primary',
  secondary: 'text-secondary',
  success:   'text-success',
  danger:    'text-danger',
  theme:     'text-theme',
  muted:     'text-gray-400',
  black:     'text-black',
};

export const PRIMENG_SIZE_MAP: Record<IconSize, string> = {
  xxs:     'icon-xxs',
  xs:      'icon-xs',
  sm:      'icon-sm',
  default: 'icon-default',
  md:      'icon-md',
  lg:      'icon-lg',
  xl:      'icon-xl',
  xxl:     'icon-xxl',
};

/**
 * Maps our IconSize to Tailwind sizing classes (h-N w-N).
 * Passed directly to hlm-icon so the inner SVG is sized correctly
 * (hlm-icon reads these via MutationObserver when size="none").
 */
export const ICON_SIZE_CLASS_MAP: Record<IconSize, string> = {
  xxs:     'h-2 w-2',
  xs:      'h-3 w-3',
  sm:      'h-4 w-4',
  default: 'h-5 w-5',
  md:      'h-6 w-6',
  lg:      'h-7 w-7',
  xl:      'h-8 w-8',
  xxl:     'h-10 w-10',
};
